import { Button, ButtonGroup, HStack } from "@chakra-ui/react";
import { DataTable } from "@components/ui-kit";
import { Pagination } from "@components/ui-kit/table/pagination";
import { Trans, t } from "@lingui/macro";
import {
  type ContractsWhereColumn,
  type OrdersWhereColumn,
  type OtherDocumentsWhereColumn,
  useContractsExportLazyQuery,
} from "@src/__generated__/graphql";
import { Icon } from "@src/components/ui-kit/Icon";
import { FiltersPanel } from "@src/utils/components/filters/components/filters-panel";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { AddDocumentBtn, DocumentsTables, TabTableNavigation } from "./Common";
import {
  DocumentsCtx,
  type ExternalLinkColumns,
  QuickFilters,
} from "./StoreDocuments";

export const CardListDocuments = observer(function CardListDocuments() {
  const store = useContext(DocumentsCtx);

  const [fetchContractsExport, { loading: contractsExportLoading }] =
    useContractsExportLazyQuery({
      onCompleted(data) {
        const contractsExport = data?.contractsExport;
        if (contractsExport) window.location.href = contractsExport;
      },
    });

  return (
    <DataTable>
      <DataTable.NavBar>
        <HStack justifyContent="space-between">
          <TabTableNavigation store={store} />
          <ButtonGroup spacing="2">
            {store.activeQuickFilter === QuickFilters.Contracts && (
              <Button
                colorScheme="grey"
                isLoading={contractsExportLoading}
                leftIcon={<Icon name="download-02" />}
                onClick={() => fetchContractsExport()}
                variant="outline"
              >
                <Trans>Export Contracts</Trans>
              </Button>
            )}
            <AddDocumentBtn />
          </ButtonGroup>
        </HStack>
      </DataTable.NavBar>
      <DataTable.Filter>
        <FiltersPanel<
          | ContractsWhereColumn
          | OrdersWhereColumn
          | OtherDocumentsWhereColumn
          | ExternalLinkColumns
        >
          filters={store.where}
          searchPlaceholder={t`Search`}
          onSearch={(val) => {
            store.searchTerm = val;
            store.pagination.resetPage();
          }}
        />
      </DataTable.Filter>

      <DocumentsTables store={store} />
      {store.activeQuickFilter !== QuickFilters.ExternalLinks && (
        <Pagination store={store.pagination} />
      )}
    </DataTable>
  );
});
